import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'
import { Box, Loader, Text } from '@mantine/core'
import { Outlet, useLocation } from 'react-router-dom'
import { useWorkspaceTabs } from '@/lib/workspace-tabs-context'
import { pageTitleFromPath } from '@/lib/page-title'
import { buildRoutePath, parseRouteTo } from '@/lib/route-title'

const ease = [0.22, 1, 0.36, 1] as const

/**
 * Лёгкий переход между маршрутами: opacity + короткий сдвиг по Y.
 * Уважает prefers-reduced-motion.
 */
export function AnimatedOutlet() {
  const location = useLocation()
  const { pendingPath } = useWorkspaceTabs()
  const reduceMotion = useReducedMotion()
  const duration = reduceMotion ? 0 : 0.12
  const currentPath = buildRoutePath(location.pathname, location.search || '')
  const showPending = Boolean(pendingPath && pendingPath !== currentPath)
  const pendingRoute = pendingPath ? parseRouteTo(pendingPath) : null
  const pendingTitle = pendingRoute
    ? pageTitleFromPath(pendingRoute.pathname, pendingRoute.search)
    : 'Загрузка'

  return (
    <AnimatePresence mode="sync">
      <motion.div
        key={showPending ? `pending:${pendingPath}` : currentPath}
        initial={{ opacity: reduceMotion ? 1 : 0, y: reduceMotion ? 0 : 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: reduceMotion ? 1 : 0, y: reduceMotion ? 0 : -4 }}
        transition={{ duration, ease }}
        style={{
          flex: '1 1 0%',
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {showPending ? (
          <Box
            style={{
              flex: '1 1 0%',
              minHeight: 0,
              minWidth: 0,
              display: 'grid',
              placeItems: 'center',
              background: 'var(--mantine-color-body)',
            }}
          >
            <Box style={{ display: 'grid', justifyItems: 'center', gap: 10 }}>
              <Loader size="sm" />
              <Text size="sm" c="dimmed">
                {pendingTitle}
              </Text>
            </Box>
          </Box>
        ) : (
          <Outlet />
        )}
      </motion.div>
    </AnimatePresence>
  )
}
